import React, { Fragment, useState, useEffect } from "react";
import {getAuthorization} from "../../../axios/AxiosAut";
import Table, {
  AvatarCell,
  GroupsInvolved,
  SelectColumnFilter,
  StatusPill,
} from "../../table/Table"; // new
import { useDispatch, useSelector } from "react-redux";
import { setAPIDetailsStaffTable } from "../../../redux/slices/statistics/statisticSlice";
import { Dialog, Transition } from "@headlessui/react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

function CompnayStaffTableData() {
  const [CompanyEmployees, setCompanyEmployees] = useState([]);
  const APIDetailsStaffTable = useSelector(
    (state) => state.statistics.APIDetailsStaffTable
  );
  const dispatch = useDispatch();
  const AddMemberInitialValues = {
    email: "",
    job_role: "",
    redirect_url: "http://localhost:3000/login",
  };
  const MemberValidationSchema = Yup.object({
    email: Yup.string().email("Invalid Email").required("Email Required"),
    job_role: Yup.string()
      .min(2, "Too short!")
      .max(20, "Too long!")
      .required("Required"),
  });
  const HandleSubmitAddMember = (values, onSubmitProps) => {
    getAuthorization()
      .post("company/send_staff_invite/", values)
      .then((res) => {
        console.log("values", values);
        setOpen(false);
        onSubmitProps.setSubmitting(false);
        // setTimeout(() => {
        //   ShowMemberNotification();
        // }, 1000);
      })
      .catch((err) => {
        console.log("Error in adding member", err);
        onSubmitProps.setSubmitting(false);
      });
  };
  const getCompanyEmployee = () => {
    getAuthorization()
      .get("company/company_employees/")
      .then((res) => {
        setCompanyEmployees(res.data);
        dispatch(setAPIDetailsStaffTable(res.data));
      })
      .catch((err) => {
        console.log("Error in getting user groups", err);
      });
  };
  const [open, setOpen] = useState(false);

  const MemberModalHandler = () => {
    setOpen(true);
  };
  useEffect(() => {
    //Get Company Employees
    if (APIDetailsStaffTable.length === 0) {
      getCompanyEmployee();
      console.log("inside useefeect");
    }
  }, []);
  const data = APIDetailsStaffTable;
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "full_name",
        Cell: AvatarCell,
        imgAccessor: "profile_picture",
      },
      {
        Header: "Job Role",
        accessor: "job_role",
        // Filter: SelectColumnFilter, // new
        filter: "includes",
      },
      {
        Header: "Groups Involved",
        accessor: "groups_involved",
        Cell: GroupsInvolved,
      },
      {
        Header: "Action",
        // accessor: "action",
      },
    ],
    []
  );

  return (
    <div className="min-h-screen">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-3">
          <Table columns={columns} data={data} text="Undefined" />
        </div>
      </main>
    </div>
  );
}

export default CompnayStaffTableData;
